import { useState } from 'react';
import Nav from '../sections/Nav';
import Industries from '../sections/Industries';
import WhyNow from '../sections/WhyNow';
import Footer from '../sections/Footer';
import ContactForm from '../ContactForm';
import { useSEO } from '../useSEO';

const IndustriesPage = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [contactFormMode, setContactFormMode] = useState('contact');

  useSEO({
    title: 'Industries | Nthra Labs',
    description: 'Digital Material Passport for automotive, aerospace, EV & battery, textiles, and pharma — deterministic proof of conformance for the industries where evidence has to hold up downstream.',
    path: '/industries',
  });

  const openContactForm = (mode) => {
    setContactFormMode(mode);
    setIsContactFormOpen(true);
  };

  return (
    <div style={{ fontFamily: "'DM Sans',sans-serif", background: '#ffffff', color: '#1a1a1a', minHeight: '100vh' }}>
      <Nav onOpenContact={openContactForm} />
      <h1 className="sr-only">Industries We Serve — Automotive, Aerospace, EV & Battery, Textiles, Pharma</h1>
      <div style={{ paddingTop: 24 }} />
      <Industries />
      <WhyNow />
      <Footer />
      <ContactForm
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
        mode={contactFormMode}
      />
    </div>
  );
};

export default IndustriesPage;
